import { getCookie } from 'stash/utils/cookies';

import {
	ACCESS_TOKEN_COOKIE_NAME,
	USER_ID_COOKIE_NAME,
	REFRESH_TOKEN_COOKIE_NAME,
	UUID_COOKIE_NAME,
} from 'stash/constants/session';
import {
	getPortfolioBuilderHandoffCompletedStorageKey,
	PORTFOLIO_BUILDER_HANDOFF_COMPLETED_STATE_KEY,
} from 'stash/components/screens/portfolio-builder-handoff/constants';

type HydratedState = {
	application: {
		signUp: {
			completed: Record<string, boolean>;
		};
	};
	entities: {
		api_key: {
			user_id: string | undefined;
			uuid: string | undefined;
			access_token: string | undefined;
			refresh_token: string | undefined;
		};
	};
};

export function hydrateStateFromCookies(): HydratedState {
	const userUuid = getCookie(UUID_COOKIE_NAME);
	const portfolioBuilderHandoffStorageKey = getPortfolioBuilderHandoffCompletedStorageKey(userUuid);
	let isPortfolioBuilderHandoffComplete = false;
	if (portfolioBuilderHandoffStorageKey) {
		try {
			isPortfolioBuilderHandoffComplete =
				window.localStorage.getItem(portfolioBuilderHandoffStorageKey) === 'true';
		} catch {
			isPortfolioBuilderHandoffComplete = false;
		}
	}

	return {
		application: {
			signUp: {
				completed: isPortfolioBuilderHandoffComplete
					? {
							[PORTFOLIO_BUILDER_HANDOFF_COMPLETED_STATE_KEY]: true,
						}
					: {},
			},
		},
		entities: {
			api_key: {
				user_id: getCookie(USER_ID_COOKIE_NAME),
				uuid: userUuid,
				access_token: getCookie(ACCESS_TOKEN_COOKIE_NAME),
				refresh_token: getCookie(REFRESH_TOKEN_COOKIE_NAME),
			},
		},
	};
}
